import { Component, OnInit, ViewChild } from "@angular/core";
import {
  MatTableDataSource, PageEvent, MatDialog,
   MatPaginator
} from "@angular/material";
import { Router } from "@angular/router";
import { User} from "src/_models/users";
import { AppService } from "src/_services/app.service";
import { AuthenticationService } from "src/_services/authentication.service";


@Component({
  selector: "app-user-history",
  templateUrl: "./user-history.component.html",
  styleUrls: ["./user-history.component.scss"],
})
export class UserHistoryComponent implements OnInit {
  usersDisplayedColumns: string[] = [
    "Username",
    "Date",
    "IP",
    "Audittype",
  ];
  
  userRole: any = JSON.parse(sessionStorage.getItem("currentUser"));
  users = new MatTableDataSource<User>();
  constructor(
    private appService: AppService,
    private router: Router,
    private authService: AuthenticationService
  ) {}

  ngOnInit() {
    this.getReportData();
  }

  @ViewChild(MatPaginator) paginator: MatPaginator;
  getReportData() {}
}